import * as React from 'react';
import styled from '@emotion/styled';
var S;
(function (S) {
    S.Container = styled.div ``;
})(S || (S = {}));
export const VerifyPage = (props) => {
    return React.createElement(S.Container, null, "Hello");
};
